import { UserManager, WebStorageStateStore } from 'oidc-client-ts';

/**
 * Client OIDC public sur le realm `elika` de Keycloak.
 *
 * Aucun secret ici : le navigateur ne peut rien garder de confidentiel. La
 * sécurité repose sur PKCE (S256) et sur la liste blanche de redirections
 * déclarée côté Keycloak.
 *
 * Entra ID reste la source des identités — Keycloak le fédère. L'utilisateur
 * voit donc toujours l'écran Microsoft, mais l'application ne parle qu'à
 * Keycloak, comme portal.elikateam.com et erp.elikateam.com.
 *
 * En développement, tester sur http://localhost:3214 et non sur une IP de LAN :
 * PKCE S256 a besoin de `crypto.subtle`, indisponible hors contexte sécurisé.
 */
export const oidcConfig = {
  authority: process.env.REACT_APP_KEYCLOAK_ISSUER,
  client_id: process.env.REACT_APP_KEYCLOAK_CLIENT_ID || 'salepulse',
  redirect_uri: `${window.location.origin}/`,
  post_logout_redirect_uri: `${window.location.origin}/`,
  response_type: 'code',
  scope: 'openid profile email',
  // Le jeton applicatif prend le relais après l'échange : inutile de garder une
  // session OIDC vivante côté navigateur.
  automaticSilentRenew: false,
  loadUserInfo: false,
  // sessionStorage : la session tombe à la fermeture de l'onglet.
  stateStore: new WebStorageStateStore({ store: window.sessionStorage }),
  userStore: new WebStorageStateStore({ store: window.sessionStorage }),
};

export const userManager = new UserManager(oidcConfig);

/** Vrai si l'URL courante est le retour de redirection Keycloak. */
export const isRedirectCallback = () => {
  const params = new URLSearchParams(window.location.search);
  return params.has('code') && params.has('state');
};

/** Retire les paramètres OIDC de la barre d'adresse après l'échange. */
export const cleanCallbackUrl = () => {
  window.history.replaceState({}, document.title, window.location.pathname);
};
